module.exports = __webpack_public_path__ + "static/media/d7.329635da.gif";